import { useState } from 'react'

import { SlugConflictError } from './org-slug.util'

interface SlugConflictCallbacks {
  onError: (message: string) => void
  onClearError: () => void
  onApplySlug: (slug: string) => void
}

interface UseSlugConflictReturn {
  suggestions: string[]
  handleConflictError: (error: unknown) => boolean
  resetSuggestions: () => void
  selectSuggestion: (slug: string) => void
}

export const useSlugConflict = ({
  onError,
  onClearError,
  onApplySlug,
}: SlugConflictCallbacks): UseSlugConflictReturn => {
  const [suggestions, setSuggestions] = useState<string[]>([])

  const handleConflictError = (error: unknown): boolean => {
    if (error instanceof SlugConflictError) {
      onError('This URL is already taken')
      setSuggestions(error.suggestions)
      return true
    }
    return false
  }

  const resetSuggestions = (): void => {
    setSuggestions([])
  }

  const selectSuggestion = (slug: string): void => {
    onApplySlug(slug)
    onClearError()
    setSuggestions([])
  }

  return { suggestions, handleConflictError, resetSuggestions, selectSuggestion }
}
